<template>
  <div class="onstop-project-detail" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="项目详情" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="case-info-detail">
      <div class="project-info">
        <div>{{onestopProject.name}}</div>
        <div>{{onestopProject.status == '6' ? '已完工' : '未完工'}}</div>
      </div>
      <div class="project-house-type">
        {{onestopProject.houseLayout}}&nbsp;&nbsp;&nbsp;{{onestopProject.area}}㎡
      </div>
    </div>
    <div class="supervisor-info general-box-shadow">
      <img class="supervisor-avatar" :src="imgUrl + onestopCompany.logo">
      <div class="supervisor-less-info">
        <div>
          <span>公司</span>
          <span class="supervisor-name">{{onestopCompany.name}}
            <span class="upervisor-name-evaluate-score">
              <span class="upervisor-name-score">{{companyEvaluate.avgScore | score}}</span>
            </span>
          </span>
        </div>
        <div class="supervisor-auth">
          <div class="platform-auth"><img src="../../assets/appointment/icon-platform-auth.png"/> <div>平台认证</div></div>
          <div class="supervisor-deposit"><img src="../../assets/appointment/icon-deposit-auth.png"/><div>10 万</div></div>
        </div>
      </div>
      <!-- <div class="evaluate-score">
        <div class="score">{{companyEvaluate.avgScore | score}}</div>
        评分
      </div> -->
    </div>
    <div class="work-progress">
      <div style="display: flex">
        <div class="wp-title" @click="changeTabSelect('1')" :class="{'selected': tabItemSelect == '1'}">施工</div>
        <div class="wp-title" @click="changeTabSelect('2')" :class="{'selected': tabItemSelect == '2'}">账单</div>
        <div v-if="!!global.isMiniProgrm && !!onestopProject.camera" class="wp-title" @click="changeTabSelect('4')" :class="{'selected': tabItemSelect == '4'}">工地直播</div>
        <div class="wp-title" @click="changeTabSelect('3')" :class="{'selected': tabItemSelect == '3'}">评价</div>
      </div>
      <div class="wp-body" v-if="tabItemSelect == '1'">
        <div class="wp-row" v-for="stage in projectStage" v-if="stage.type != '0'">
          <div class="wp-label" :class="{'active': stage.status === '3'}"></div>
          <div class="wp-content" :class="{'complete': stage.status === '3'}">{{stage.stageName}}
            <div v-if="stage.status === '3'" class="wp-date">{{stage.completeTime | simpleDayFilter}}</div>
          </div>
        </div>
      </div>
      <div class="wp-body" v-if="tabItemSelect == '2'">
        <div class="bill-list">
          <div class="bill-item" v-for="fee in projectStageFee">
            <div class="bill-info">
              <div class="bill-name">{{fee.name || '合同款'}}</div>
              <div class="bill-status-prepay" v-if="fee.status == '0' && fee.priceStage">待支付</div>
              <div class="bill-status-prepay" v-if="!fee.priceStage">待录入金额</div>
              <div  class="bill-status-prepay" v-if="stageFee.id == fee.id && customerPayVoucher.stageFeeId == fee.id">{{payVoucherStatus}}</div>
              <div  class="bill-status-paid" v-if="fee.status == '1'">已支付</div>
            </div>
            <div class="bill-amount" v-if="fee.priceStage"><span>￥</span>{{fee.priceStage}}</div>
          </div>
        </div>
        <div style="display: flex;justify-content: center;align-items: center;width:100%">
          <div class="pre-payment-btn1" v-if="stageFee.status != '1' " @click="openConfirmPaymentOnestop(onestopProject.id,onestopProject.status,onestopProject.type)">立即支付</div>
        </div>
        <div class="pre-payment-btn" v-if="stageFee.payType == '3' && customerPayVoucher.checkStatus == '3'" @click="openConfirmPaymentOnestop(onestopProject.id,onestopProject.status,onestopProject.type)">重新上传支付凭证</div>
        <div style="clear: both"></div>
      </div>

      <div v-if="global.isMiniProgrm && tabItemSelect == '4'">
        <!--        <div class="live-card" v-if="!global.isMiniProgrm">-->
        <!--          <EZUIKitJs autoplay></EZUIKitJs>-->
        <!--        </div>-->
        <!--        -->
        <div class="live-card">
          <div @click="decoratingLive" class="openMiniProgrm"></div>
        </div>
      </div>
    </div>
    <div class="client-evaluate" v-if="tabItemSelect === '3' && customerEvaluateList.length > 0">
      <div class="client-evaluate-item" v-for="(evaluate,index) in customerEvaluateList" :class="{'broder-top' : index > 0}">
        <div class="client-info">
          <img class="client-info-img" :src="evaluate.customerUser.avatarUrl">
          <div class="client-info-right">
            <div class="cir-name-star">
              <span class="cir-name">{{evaluate.customerName}}</span>
              <div class="cir-star">
                <div class="star-img" :class="evaluate.score <= 0 ? '' : (evaluate.score >=1 ? 'on': '')"></div>
                <div class="star-img" :class="evaluate.score <= 1 ? '' : (evaluate.score >=2 ? 'on': '')"></div>
                <div class="star-img" :class="evaluate.score <= 2 ? '' : (evaluate.score >=3 ? 'on': '')"></div>
                <div class="star-img" :class="evaluate.score <= 3 ? '' : (evaluate.score >=4 ? 'on': '')"></div>
                <div class="star-img" :class="evaluate.score <= 4 ? '' : (evaluate.score >=5 ? 'on': '')"></div>
              </div>
            </div>
            <div class="cir-address-time">
              <span v-if="evaluate.type" class="cir-address">To{{evaluate.type == '1' ? '监理' : '工长'}} : {{evaluate.to}}</span>
              <span v-if="!evaluate.type" class="cir-address"></span>
              <span class="cir-time">{{evaluate.createTime | time}} <img v-if="evaluate.update" @click="toCustomerEvaluateEdit(evaluate.id)" style="width:0.29rem;height: 0.3rem;margin-left: 0.25rem" src="../../assets/icon/icon-evaluate-edit-btn.png"/></span>
            </div>
          </div>
        </div>
        <p class="client-intro">{{evaluate.content}}</p>
      </div>
    </div>
    <div class="client-evaluate-form" v-if="tabItemSelect === '3' && showEvaluate < maxEvaluate && onestopProject.status == '6'">
      <div class="evaluate-header-title">
        项目评价
      </div>
      <div class="evaluate-text">
        <textarea rows="5" v-model="content" placeholder="评价只能修改一次 请您谨慎填写"></textarea>
      </div>
      <div class="footer">
        <div>总体评分</div>
        <div class="evaluate-star">
          <div class="star-img" v-model="score" :class="score <= 0 ? '' : (score >=1 ? 'on': 'off')" @click="selectScore(1)"></div>
          <div class="star-img" v-model="score" :class="score <= 1 ? '' : (score >=2 ? 'on': 'off')" @click="selectScore(2)"></div>
          <div class="star-img" v-model="score" :class="score <= 2 ? '' : (score >=3 ? 'on': 'off')" @click="selectScore(3)"></div>
          <div class="star-img" v-model="score" :class="score <= 3 ? '' : (score >=4 ? 'on': 'off')" @click="selectScore(4)"></div>
          <div class="star-img" v-model="score" :class="score <= 4 ? '' : (score >=5 ? 'on': 'off')" @click="selectScore(5)"></div>
        </div>
      </div>
      <div class="evaluate-btn" :class="{'wait-send' : !insertEvaluateStatus}" @click="insertEvaluate()">提&nbsp;&nbsp;交</div>
      <div class="clear"></div>
      <div v-if="showTip" class="toast general-tip-modal">
        <img class="close-btn" src="../../assets/icon-close-btn.png" @click="closeTip()">
        <div class="general-modal-title border-bottom-style">温馨提示</div>
        <div class="general-modal-msg">您还未选择评分<br/>请您评分完成再提交评价!</div>
        <div class="agree-btn" @click="closeTip()">确定</div>
      </div>
      <div v-if="showTip" class="pay-box"></div>
    </div>
  </div>
</template>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .onstop-project-detail{
    background-color: white;
    font-size: 0.36rem;
    .case-info-detail{
      height: 1.64rem;
      background-image: url('../../assets/icon-default-top-bg.png');
      color: white;
      .project-info{
        display: flex;
        justify-content: space-between;
        padding: 0.3rem 0.3rem 0.2rem 0.3rem;
        font-weight: bold;
      }
      .project-house-type{
        width: 2.95rem;
        height: 0.4rem;
        line-height: 0.45rem;
        border-radius: 0.4rem;
        margin-left: 0.3rem;
        text-align: center;
        background: white;
        font-size: 0.24rem;
        color: #feac00;
      }
    }
    .supervisor-info{
      position: relative;
      display: flex;
      width: 6.9rem;
      height: 1.9rem;
      margin: 0.3rem auto 0;
      border-radius: 0.08rem;
      box-shadow: 0rem 0.02rem 0.07rem 0rem
      rgba(0, 0, 0, 0.1);
      .supervisor-avatar{
        width: 1.3rem;
        height: 1.3rem;
        border-radius: 0.06rem;
        margin: 0.3rem 0.2rem;
      }
      .supervisor-less-info{
        margin-top: 0.4rem;
        font-size: 0.28rem;
        color: #7f7d7c;
        .supervisor-name{
          margin-left: 0.2rem;
          font-weight: bold;
          font-size: 0.36rem;
          color: #191818;
          .upervisor-name-evaluate-score{
            position: absolute;
            // right: 0.21rem;
            background: url("../../assets/icon-score-bg.png") no-repeat;
            margin-top: 0.14rem;
            margin-left: 0.1rem;
            width: 0.56rem;
            height: 0.6rem;
            line-height: 0.25rem;
            background-size: 110%;
            font-size: 0.18rem;
            color: rgb(224,112,112);
            text-align: center;
            .upervisor-name-score{
              margin-left: 0.24rem;
              font-size: 0.16rem;
              font-weight: bold;
            }
          }
        }
        .supervisor-auth{
          display: flex;
          width: 2.95rem;
          height: 0.4rem;
          line-height: 0.45rem;
          border-radius: 0.4rem;
          margin-top: 0.19rem;
          background: #e0dedc;;
          font-size: 0.24rem;
          color: #191818;
          img{
            width: 0.27rem;
            height: 0.28rem;
            margin-top: 0.06rem;
            margin-right: 0.1rem;
          }
          .platform-auth{
            display: flex;
            padding-left: 0.23rem;
          }
          .supervisor-deposit{
            display: flex;
            padding-left: 0.29rem;
          }
        }
      }
      .evaluate-score{
        position: absolute;
        right: 0.21rem;
        background: url("../../assets/icon-evaluate-bg.png") no-repeat;
        width: 0.58rem;
        height: 0.8rem;
        line-height: 0.25rem;
        background-size: 100%;
        font-size: 0.18rem;
        color: white;
        text-align: center;
        .score{
          margin-top: 0.05rem;
          font-size: 0.24rem;
          font-weight: bold;
        }
      }
    }
    .work-progress{
      padding-left: 0.3rem;
      padding-bottom: 0.2rem;
      .wp-title{
        height: 1.05rem;
        line-height: 1.1rem;
        margin-right: 0.3rem;
        color: #191818;
        font-size: 0.32rem;
      }
      .selected{
        font-weight: bold;
      }
      .wp-body{
        width: 6.9rem;
        padding-top: 0.33rem;
        padding-bottom: 0.6rem;
        box-shadow: 0rem 0.02rem 0.07rem 0rem
        rgba(0, 0, 0, 0.1);
        .node-img-list{
          display: flex;
          flex-wrap: wrap;
          width: 6rem;
          img{
            display: block;
            width: 1.75rem;
            height: 1.75rem;
            margin-top: 0.2rem;
            margin-right: 0.2rem;
          }
        }
        .bill-list{
          margin-top: -0.3rem;
          .bill-item{
            margin: 0.3rem;
          }
          .bill-info{
            display: flex;
            justify-content: space-between;
            color: #7f7d7c;
            font-size: 0.28rem
          }
          .bill-name{
            margin-bottom: 0.15rem;
            color: #00478e;
            background:rgb(243,249,255);
            padding: 0.1rem;
          }
          .bill-status-prepay{
            color: #feac00;
          }
          .bill-status-paid{
            // color: #191818;
            color: #00478e;
          }
          .bill-amount{
            font-size: 0.6rem;
            color: #d54a33;
            span{
              font-size: 0.36rem;
            }
          }
        }
        .pre-payment-btn1{
          background-color: #00478e;
          border-radius: 5px;
          width: 85%;
          height: 50px;
          line-height: 50px;
          font-size: 17px;
          text-align: center;
          color: white;
        }
        .pre-payment-btn{
          height: 0.7rem;
          line-height: 0.73rem;
          padding: 0 0.3rem;
          margin-right: 0.3rem;
          background-color: #feac00;
          border-radius: 0.4rem;
          font-size: 0.32rem;
          color: white;
          text-align: center;
          float: right;
        }
      }
      .none-complete-img{
        font-size: 0.28rem;
        color: #d5dee2;
        padding-top: 1.73rem;
        text-align: center;
        img{
          width: 0.72rem;
          height: 0.6rem;
        }
      }
      .live-card{
        width: 6.9rem;
        height: 3.6rem;
        font-size: 0.28rem;
        color: #d5dee2;
        text-align: center;
        img{
          width: 0.72rem;
          height: 0.6rem;
        }
        .openMiniProgrm{
          position: relative;
          width: 100%;
          height: 100%;
          border-radius: .1rem;
          font-size: 0.32rem;
          color: white;
          background-image: url("../../assets/mine/live_cover.png");
          background-size: 100% 100%;
          content: " ";
          &:after{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            display: block;
            content: " ";
            width: 1rem;
            height: 1rem;
            background-image: url("../../assets/mine/ctrl-play.png");
            background-size: 100% 100%;
          }
        }
      }
      .wp-row{
        padding-left: 0.2rem;
        margin-top: 0.6rem;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        .wp-label{
          position: relative;
          width: 0.36rem;
          margin-top: 0.05rem;
          background: url("../../assets/icon/icon-stage-uncomplete.png") no-repeat;
          background-size: 100%;
          flex-grow: 0;
          flex-shrink: 0;
          &.active{
            width: 0.36rem;
            margin-top: 0.05rem;
            background: url("../../assets/icon/icon-stage-complete.png") no-repeat;
            background-size: 100%;
          }
        }
        &:first-child{
          margin-top:0px;
        }
        .wp-content{
          margin-left: 0.2rem;
          color: #7f7d7c;
          font-size: 0.32rem;
          font-weight: bold;
          flex-grow: 1;
          flex-shrink: 0;
          &.complete{
            color: #191818;
          }
          .wp-date{
            font-weight: normal;
            font-size: 0.24rem;
            color: #cecbca;
          }
        }
      }
    }
    .client-evaluate{
      background-color: white;
      padding-bottom: 0.2rem;
      padding-left: 0.28rem;
      .client-evaluate-item{
        padding-top: 0.4rem;
        padding-right: 0.28rem;
        .client-info{
          display: flex;
          .client-info-img{
            width: 0.89rem;
            height: 0.89rem;
            border-radius: 1rem;
            background-color: #999;
          }
          .client-info-right{
            flex-grow: 1;
            padding-left: 0.3rem;
            .cir-name-star{
              font-size: 0.32rem;
              color: #1B1E29;
              display: flex;
              justify-content: space-between;
              align-items: center;

              .cir-star{
                display: flex;
                justify-content: flex-end;

                .star-img {
                  width: 0.32rem;
                  height: 0.3rem;
                  margin-left: 0.1rem;
                  background-image: url("../../assets/icon/icon-star-off.png");
                  background-size: 100%;
                }
                .on{
                  background-image: url("../../assets/icon/icon-star-on.png");
                }
                .off{
                  background-image: url("../../assets/icon/icon-star-off.png");
                }
              }
            }
            .cir-address-time{
              margin-top: 0.1rem;
              color: #878E99;
              display: flex;
              justify-content: space-between;
            }
          }
        }
        .client-intro{
          text-align: left;
          margin-top: 0.2rem;
          margin-bottom: 0.38rem;
          color: #878E99;
          line-height: 0.39rem;
        }
      }
      .broder-top{
        border-top: solid 0.02rem #DAE2E5;
      }
    }
    .client-evaluate-form{
      width: 6.9rem;
      margin: 0 auto;
      padding: 0 0.28rem;
      background-color: white;
      .evaluate-header-title{
        height: 0.78rem;
        display: flex;
        align-items: center;
        font-weight: bold;
      }
      .evaluate-text{
        width: 100%;
        textarea{
          width: calc(100% - 0.57rem);
          height: 1.77rem;
          color: #1B1E29;
          line-height: 0.42rem;
          background-color: #f7f6f5;
          padding: 0.23rem 0.23rem 0.23rem 0.34rem;
          resize: none;
          outline: none;
          font-size: 0.32rem;
          ::placeholder{
            color: #cecbca;
          }
        }
      }
      .footer{
        display: flex;
        justify-content: space-between;
      }
      .evaluate-star{
        display: flex;
        align-items: center;
        font-weight: bold;
      }
      .star-img {
        width: 0.32rem;
        height: 0.3rem;
        margin-left: 0.1rem;
        background-image: url("../../assets/icon/icon-star-off.png");
        background-size: 100%;
      }
      .on{
        background-image: url("../../assets/icon/icon-star-on.png");
      }
      .off{
        background-image: url("../../assets/icon/icon-star-off.png");
      }
      .evaluate-btn{
        float: right;
        width: 1.68rem;
        height: 0.6rem;
        margin-top: 0.4rem;
        margin-bottom: 1.17rem;
        background-color: #feac00;
        text-align: center;
        line-height: 0.6rem;
        border-radius: 1rem;
        color: white;
        font-size: 0.32rem;
      }
    }
    .wait-send{
      pointer-events: none;
    }
    .clear-header{
      margin-top: -1rem;
    }
  }
</style>

<script>
  import {imgUrl,shareIcon} from '../../config'
  import {MessageBox,Indicator,Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import onestopProjectService from '../../service/customer/ProjectService'
  import evaluateService from '../../service/customer/EvaluateService'
  import shareService from '../../service/share/ShareService'
  import statusIconRight from '../../assets/icon_right.png'
  import statusIconWrong from '../../assets/icon_wrong.png'
  import customerPayVoucherService from '../../service/customer/CustomerPayVoucherService'
  import Preview from '../../components/preview/preview'
  import baseService from '../../service/BaseService'
  import companyService from '../../service/company/CompanyService'
  import session from '../../utils/Session'

  export default {
    name: 'OnestopProjectDetail',
    components: {
      'my-header': Header,
      'preview': Preview,
    },
    data () {
      return {
        onestopProject:{},
        onestopCompany:{},
        projectStage:[],
        stage:{},//当前工地验收进度
        projectStageFee:[],
        customerPayVoucher:{},
        payVoucherStatus:'',
        stageFee:{status:'1'},//当前该支付的阶段
        imgUrl:imgUrl,
        shareIcon:shareIcon,
        customerEvaluateList:[],
        score:0,
        showEvaluate:0,
        maxEvaluate:0,
        insertEvaluateStatus:true,
        content:'',
        evaluateWho:1,
        projectType:'1',
        isWechatBrowser:this.$verfyBrowserType(),
        projectName:'',
        tabItemSelect: '1',
        attachmentUrlList:[],
        customerContractImages:'',
        sheetVisible:false,
        actions:[],
        showImage:'',
        showBig:false,
        showContractSaveBtn:false,
        onestopStatusMap:[],
        companyEvaluate:{},
        showTip:false,
        companyId:'',
        isCurrentUserProject:false
      }
    },
    created(){
      this.projectStatus = this.$route.query.projectStatus;
      this.projectName = this.$route.query.projectName;
      this.onestopProject.id = this.$route.query.onestopProjectId || '';
      this.projectType = this.$route.query.type;
      this.companyId = this.$route.query.companyId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getOnestopProjectDetail(this.onestopProject.id);
      this.getProjectStageFee();
      if (this.global.tabItemSelect) {
        this.tabItemSelect = this.global.tabItemSelect;
        this.global.tabItemSelect = '';
      };
    },
    methods: {
      changeTabSelect(select){
        this.tabItemSelect = select;
      },
      selectScore(score){
        this.score = score;
      },
      decoratingLive(){
        if(this.onestopProject.camera){
          const { deviceSerial, deviceCode } = this.onestopProject.camera
          if(this.global.isMiniProgrm){
            wx.miniProgram.navigateTo({url: `/pages/decorating/live?deviceSerial=${deviceSerial}&code=${deviceCode}`});
          } else {
            // this.$router.push({name:'DecorationLive',query:{ onestopProjectId: this.onestopProjectId }});
            console.log('暂不支持h5观看,请在水木家居小程序打开');
          }
        } else {
          Toast('项目没有设置摄像头');
        }
      },
      closeTip(){
        this.showTip = false;
      },
      whoClick(num){
        if(num == 1){
          this.evaluateWho=1;
        }else {
          this.evaluateWho=0;
        }
      },
      // toOnestopCompany(companyId){
      //   this.$router.push({name:'OnestopCompany',query:{companyId}});
      // },
      async getOnestopProjectDetail(id){//整包项目详情
        var result = await onestopProjectService.getOnestopProjectDetail(id);
        if(result.code == 0){
          this.onestopProject = result.data;
          this.getOnestopCompanyInfo(this.onestopProject.companyId);
          this.isCurrentUserProject = this.onestopProject.customerId == session.getAccountToken().id;
          this.onestopStatusMap = this.onestopProject.onestopStatusMap;
          this.projectName = this.onestopProject.name;
          this.initWechatShare();

          if(this.onestopProject.customerContracts){
            this.customerContractImages = this.onestopProject.customerContracts;
            this.attachmentUrlList = this.customerContractImages.split(',')
          }else {
            this.showContractSaveBtn = true;
            this.attachmentUrlList = [];
          }
          this.getEvaluateList();
          this.getProjectStage(this.onestopProject.id);
        }else {
          Toast('获取整包项目详情信息失败');
        }
      },
      async getOnestopCompanyInfo(id){
        var result = await companyService.getCompanyInfo(id);
        if(result.code == 0){
          this.onestopCompany = result.data.company;
        }else {
          Toast('获取整包公司信息失败');
        }
      },
      async getCompanyEvaluate(companyId){
        var result = await evaluateService.getCompanyEvaluate(companyId);
        if(result.code == 0){
          this.companyEvaluate = result.data;
        }else {
          Toast('获取整包公司评价信息失败');
        }
      },
      async getProjectStageFee(){
        var result = await onestopProjectService.getOnestopProjectStageFee(this.onestopProject.id,'');
        if(result.code == 0){
          this.projectStageFee = result.data.projectStageFeeList;
          console.info(this.projectStageFee)
          for(let psf of this.projectStageFee){
            console.info('psf',psf)
            if(psf.status != '1'){
              this.stageFee = psf;
              break;
            }

          }
          if(this.stageFee.payType == '3'){
            let {code,msg,data} = await customerPayVoucherService.newest(this.onestopProject.id);
            if(code == '0'){
              this.customerPayVoucher = data;
              if(this.customerPayVoucher.checkStatus == '1'){
                this.payVoucherStatus = '凭证待审核';
              } else if(this.customerPayVoucher.checkStatus == '3'){
                this.payVoucherStatus = '凭证审核不通过';
              }
            }
          }
        }else {
          Toast('获取收费列表信息失败');
        }
      },
      async getProjectStage(id){
        var result = await onestopProjectService.getOnestopProjectStage(id);
        if(result.code == 0){
          this.projectStage=result.data.stageList;
          console.info(result.data)
          for(let stage of this.projectStage){
            if(!stage.projectPatrols){
              this.$set(stage,'projectPatrols',[]);
            }
            if(stage.status === '3'){
              stage.statusIcon = statusIconRight;
              this.$set(stage,'inspected',true);
            } else {
              stage.statusIcon = statusIconWrong;
            }
          }
        }else {
          Toast('获取工地验收进度信息失败');
        }
      },
      async saveCustomerContractImages(){
        if(!this.customerContractImages){
          Toast('请上传合同明细凭证!');
          return
        }
        if(this.customerContractImages.startsWith(',')){
          this.customerContractImages = this.customerContractImages.substring(1,this.customerContractImages.length);
        }
        console.info(this.customerContractImages)
        let {code} = await onestopProjectService.saveCustomerContracts(this.onestopProject.id,this.customerContractImages);

        if(code == '0') {
          Toast('合同明细凭证提交成功!');
          this.getOnestopProjectDetail(this.onestopProject.id);
          this.showContractSaveBtn = false
        }else {
          Toast('合同明细凭证提交失败!请重新上传!');
          this.contractImages = '';
        }
      },
      async getEvaluateList(){
        this.maxEvaluate = 1;
        let res = await evaluateService.evaluateList('', this.onestopProject.companyId, this.onestopProject.id, this.onestopProject.type);
        if (res.code == 0) {
          this.customerEvaluateList = res.data;
          this.showEvaluate = this.customerEvaluateList.length;
        } else {
          Toast('获取评价信息失败');
        }
      },
      async insertEvaluate(){
        if(this.score == 0){
          this.showTip = true;
          return;
        }
        this.insertEvaluateStatus = false;
        var result=await evaluateService.evaluatePost('',this.onestopProject.id,this.score,this.content,this.onestopCompany.id);
        if(result.code == '0'){
          this.getEvaluateList();
          this.showEvaluate = 1;
          this.insertEvaluateStatus = true;
          Toast('提交成功！');
        }else {
          this.insertEvaluateStatus = true;
          Toast('评价未成功，请稍后重试！');
        }
      },
      async initWechatShare(){
        let title = this.projectName;// 分享标题
        let desc = "水木家居商城在建项目，欢迎各位莅临参观！"; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
      openCustomerVisitReservation(projectId,projectAddress,foremanName){
        if(!projectAddress){
          projectAddress = '暂无详细地址';
        }
        if(!foremanName){
          foremanName = '暂未分配工长'
        }
        this.$router.push({name:'CustomerVisitReservation',query:{projectId,projectAddress,foremanName}});
      },
      //跳转支付整包、监理或工长阶段收费页
      openConfirmPaymentOnestop(onestopProjectId,projectStatus,projectType){
        if(projectStatus == '7'){
          Toast('您的项目已终止!')
        }else if(projectType != '2'){
          this.$router.push({name:'ConfirmPaymentOnestop',query:{id:onestopProjectId}});
        }else if(projectType == '2'){
          this.$router.push({name:'ConfirmPaymentForeman',query:{id:onestopProjectId}});
        }
        this.global.tabItemSelect = this.tabItemSelect;
      },
      toNodeList(projectStage,projectId){
        if(projectStage.status == '1' && projectStage.type ==0){
         Toast('该阶段无需验收');
        }else if(projectStage.status == '1' && projectStage.type !=0){
          Toast('该阶段暂未开始验收');
        }else {
          this.$router.push({name:'OnestopProjectNodeList',query:{projectId,stageId:projectStage.stageId,stageName:projectStage.stageName,stageStatus:projectStage.status,inspectTime:projectStage.inspectTime}});
        }
        this.global.tabItemSelect = this.tabItemSelect;
      },
      toCustomerEvaluateEdit(id){
        this.$router.push({name:'CustomerEvaluateEdit',query:{id}});
      },
      async addCompleteImgs(){
        var that = this;
       if(this.onestopProject.status == '7'){
          Toast('该项目已终止!');
          return
        }else {
          if(!!this.global.isMiniProgrm){
            baseService.uploadImageWxMini().then(res =>{
              //处理image,key
              baseService.downImage({mediaId:res}).then((url)=>{
                if(!that.showContractSaveBtn){
                  that.showContractSaveBtn = true
                }
                that.customerContractImages = that.customerContractImages + ',' +url.name;
                that.attachmentUrlList.push(url.name)
              });
            }).catch(err =>{
              Indicator.close();
            });
          }else {
            //使用input文件选择
            var fileInput = document.querySelector(".image-input");
            fileInput.click();
            fileInput.onchange = function(){
              for(let file of this.files){
                let fileSize = file.size;
                if(fileSize > 0 && Math.round(fileSize/1024/1024*100)/100 < 20){
                  Indicator.open({
                    text: '加载中...',
                    spinnerType: 'fading-circle'
                  });
                  lrz(file,{width: 1024,fieldName:'imgFile',quality:0.6}).then((rst) =>{
                    return baseService.uploadImage(file);
                  }).then((url) => {
                    //处理image,key
                    if(!that.showContractSaveBtn){
                      that.showContractSaveBtn = true
                    }
                    that.customerContractImages = that.customerContractImages + ',' +url.name;
                    that.attachmentUrlList.push(url.name)
                  }).catch((err) =>{
                  }).always(()=>{
                    Indicator.close();
                  });
                }else {
                  Toast('请上传小于20M的图片!');
                }
              }
            }
          }
        }
      },
      deleteImages(index){
        var that= this;
        MessageBox.confirm('确定要删吗？删除后将无法恢复。')
          .then((action) => {
            let images = that.attachmentUrlList + '';
            let removeStr = that.attachmentUrlList[index];
            var recordImagesStr = '';
            var recordImagesArry  = images.split(",");
            for(var i=0; i<recordImagesArry.length; i++) {
              if(recordImagesArry[i] == removeStr) {
                recordImagesArry.splice(i, 1);
              }
            }
            if(recordImagesArry!=null) {
              for (var i = 0; i < recordImagesArry.length; i++) {
                recordImagesStr = recordImagesStr + ',' + recordImagesArry[i];
              }
              that.customerContractImages = recordImagesStr.substring(1, recordImagesStr.length);
            }
            that.attachmentUrlList = recordImagesArry;
            if(!that.showContractSaveBtn){
              that.showContractSaveBtn = true
            }
          }).catch(e =>{
        });
      },
      previewImg(currentImage,imageList){
        let previewImageList = [];
        for (let image of imageList){
          let previewImage = this.imgUrl + image;
          previewImageList.push(previewImage);
        }
        wx.previewImage({
          current: currentImage,
          urls: previewImageList
        });
      },
    }
  }
</script>

